(function(){

	window.addEventListener('load', function(){
		
		const range = document.createRange();
		range.selectNode(document.getElementsByTagName("head").item(0));
		
		var doDelayed = async function(id) {
			var noscript = document.getElementById(id);
			if (noscript === null) {
				console.log('#'+id+' is missed');
			} else {
				
				var scripts = range.createContextualFragment(noscript.textContent);

				while (scripts.firstElementChild) {
					try {
						if (scripts.firstElementChild.src) {	
							await (new Promise((resolve, reject) => {
								scripts.firstElementChild.onload = resolve;
								scripts.firstElementChild.onerror  = reject;
								document.body.appendChild(scripts.firstElementChild);
							}));
						} else {
							document.body.appendChild(scripts.firstElementChild);
						}
					} catch {}
				}
				document.dispatchEvent(new CustomEvent('DOMContentLoadedDelayed'));
			}

		}
		
		// Mobile Delayed Scripts
		
		/*if (window.innerWidth > 767) {
			doDelayed('mobile-delayed-scripts');
			//document.dispatchEvent(new CustomEvent('readystatechange'));
		}*/
		
		// Scripts
		document.addEventListener('mousemove', function() {
			
			requestAnimationFrame(function(){
				if (window.pageYOffset > 30){
					document.body.classList.remove('aoc-not_scrolled');
					document.body.classList.add('aoc-scrolled');
				} else {
					requestAnimationFrame(arguments.callee);
				}
			});
			
			//document.body.appendChild(range.createContextualFragment(document.getElementById("deferred-styles").textContent));
			
			/*if (window.innerWidth <= 767) {
				doDelayed('mobile-delayed-scripts');
			}*/
			doDelayed('delayed-scripts');
			
			
			// Lazyloaded scripts
			document.querySelectorAll('script[data-lazy-src]').forEach((el)=>{
				el.setAttribute('src', el.getAttribute('data-lazy-src'));
				el.setAttribute('data-lazyloaded', 1)
				el.removeAttribute('data-lazy-src');
			});
			
			// Lazyloaded iframes
			document.querySelectorAll('iframe[data-lazy-src]').forEach((el)=>{
				el.setAttribute('src', el.getAttribute('data-lazy-src'));
				el.setAttribute('data-lazyloaded', 1)
				el.removeAttribute('data-lazy-src');
			});
			
		}, { once: true});

		document.addEventListener('scroll', ()=>{
			if (window.pageYOffset > 30){
				document.dispatchEvent(new CustomEvent('mousemove'));
			}
		}, { once: true, passive: true});
		
		document.addEventListener('touchstart', ()=>{
			document.dispatchEvent(new CustomEvent('mousemove'));
		}, { once: true, passive: true});
		
	}, {
		passive: true,
	});
	
	
})();